<template>
  <v-card
    class="d-flex eq-height eq-width flex-column flex-nowrap pa-2"
  >
    <div class="d-flex flex-nowrap justify-space-between mx-3 mt-3">
      <div
        class="d-flex"
      >
        <div
          class="secondary--text font-weight-bold align-self-center"
          :class="$vuetify.breakpoint.mobile ? 'titre-h4' : 'titre-h3'"
        >
          Mon prix de vente
        </div>
        <div
          v-if="$roles.hasDroitEcritureAdminDte() && !$vuetify.breakpoint.mobile"
          class="align-self-center ml-2"
        >
          <AgrButton
            elevation="0"
            color="primary darken-1"
            outlined
            block
            @click="$router.push({name:'main.saisie-contrats-adherent'})"
          >
            <div class="d-flex">
              <v-icon
                size="20"
                class="align-self-center mr-2"
              >
                mdi-pencil
              </v-icon>
              <div class="align-self-center action --text-branche">
                Saisir les ventes de l'adhérent
              </div>
            </div>
          </AgrButton>
        </div>
      </div>
      <v-menu
        v-if="isAbonneCulturial && (contratsARepartir.length + contratsPrixProvisoire.length) > 0 && !loading.contratAdherent"
        v-model="isDisplayContratsEnAttente"
        open-on-hover
        offset-y
        :nudge-left="$vuetify.breakpoint.mobile ? 'auto' : '147'"
        top
        content-class="elevation-0"
      >
        <template v-slot:activator="{ on,attrs }">
          <v-btn
            v-bind="attrs"
            icon
            stacked
            class="position-btn-bell"
            v-on="on"
          >
            <v-badge
              avatar
              class="badge"
              location="top right"
              :offset-x="16"
              :offset-y="16"
            >
              <template v-slot:badge>
                <div class="badge-content intro">
                  {{ contratsARepartir.length + contratsPrixProvisoire.length }}
                </div>
              </template>
              <v-img
                alt="picto-graine"
                class="picto-graine"
                src="@/assets/cloche.svg"
              />
            </v-badge>
          </v-btn>
        </template>
        <div
          :class="$vuetify.breakpoint.mobile ? 'menu-item-resume-mobile' : 'menu-item-resume menu-item-resume__top pa-2'"
        >
          <div
            v-if="contratsARepartir.length"
            plain
            elevation="0"
            class="d-flex pa-2 w-100 cursor-pointer"
            @click="isOpenModalContratsRepartition = true"
          >
            <div class="intro align-self-center mr-auto">
              {{ contratsARepartir.length }} nouveau{{ contratsARepartir.length > 1 ? 'x' : '' }} contrat{{ contratsARepartir.length > 1 ? 's' : '' }} à répartir
            </div>
            <v-icon
              color="#7a8001"
            >
              mdi-chevron-right
            </v-icon>
          </div>
          <v-divider
            v-if="contratsPrixProvisoire.length && contratsARepartir.length"
            class="mx-4"
          />
          <div
            v-if="contratsPrixProvisoire.length"
            plain
            elevation="0"
            class="d-flex pa-2 w-100 cursor-pointer"
            @click="isOpenModalContratsPrixProvisoire = true"
          >
            <div class="intro align-self-center mr-auto">
              {{ contratsPrixProvisoire.length }} contrat{{ contratsPrixProvisoire.length > 1 ? 's' : '' }} avec un prix provisoire
            </div>
            <v-icon
              color="#7a8001"
            >
              mdi-chevron-right
            </v-icon>
          </div>
        </div>
      </v-menu>
      <div
        class="align-self-center ml-3"
      >
        <v-icon
          @click="isOpenModalHelp = true"
        >
          mdi-information-outline
        </v-icon>
      </div>
    </div>
    <BaseMessageServerError
      v-if="erreurGlobal"
      class="ma-auto"
    />
    <BaseLoader v-if="isAbonneCulturial && (loadingGlobal || cancelError)" />
    <div v-if="!erreurGlobal && !loadingGlobal && !cancelError">
      <div
        v-if="prixVenteAdherent.prixVenteMoyenEnEuroParTonne == null || !isAbonneCulturial"
        class="mb-2"
      >
        <div
          class="d-flex
        align-center
        flex-column"
          :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-16' "
        >
          <img
            src="@/assets/no-comparaison.svg"
            alt="no-comparaison"
          >
          <div
            class="intro texte-gris-fonce text-align-center mt-3"
            :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
          >
            <span>Retrouvez les éléments d’analyse de votre stratégie de commercialisation</span>
          </div>
        </div>
      </div>   
      <v-row
        v-if="prixVenteAdherent.prixVenteMoyenEnEuroParTonne == null || !isAbonneCulturial"
        no-gutters
        class="mt-auto pt-3 mb-5 mx-5"
      >
        <v-col
          class="px-1"
          cols="12"
          md="6"
        >
          <AgrButton
            elevation="0"
            block
            color="primary darken-1"
            outlined
            large
            @click="isOpenModalEditContrat = true"
          >
            <span class="action text-truncate --text-branche">
              Ajouter une vente</span>
          </AgrButton>
        </v-col>
        <v-col
          class="px-1"
          cols="12"
          md="6"
        >
          <AgrButton
            elevation="0"
            block
            large
            @click="onClickInformationAbonnement"
          >
            <v-icon
              v-if="!isAbonneCulturial"
              class="align-self-center mr-3"
              size="18"
              color="secondary"
            >
              mdi-lock
            </v-icon>
            <span class="action text-truncate white--text">
              Voir le bilan de mes ventes</span>
          </AgrButton>
        </v-col>
      </v-row>
      <v-row
        v-if="prixVenteAdherent.prixVenteMoyenEnEuroParTonne != null && isAbonneCulturial"
        justify="center"
        class="mb-5"
      >
        <v-col
          cols="12"
          md="5"
          offset-md="1"
          align="center"
          class="align-self-center"
        >
          <PercentageDoughnut
            :data="{
              percentage: prixVenteAdherent.poidsVenduEnPourcentage >= 100 ? 99.99 : prixVenteAdherent.poidsVenduEnPourcentage,
              value: prixVenteAdherent.poidsVenduEnTonne,
              unit: 't',
              label: 'Poids vendu affecté à la culture'
            }"
            size="240"
            width="20"
            positive-color="#dbbd00"
            negative-color="#ec6608"
          >
            <div
              class="d-flex align-self-center flex-column align-center"
            >
              <div class="d-flex">
                <div class="chiffre-xxl secondary--text align-self-center">
                  {{ prixVenteAdherent.prixVenteMoyenEnEuroParTonne |roundNumber(0) }}
                </div>
                <div class="titre-h1 secondary--text align-self-center ml-2">
                  €/t
                </div>
              </div>
              <div
                class="align-self-center"
                :class="$vuetify.breakpoint.mobile ? 'mt-3' : ''"
              >
                <BaseEvolutionWithInfo
                  :evolution-value="prixVenteAdherent.evolutionPrixVenteMoyenEnPourcentage"
                  :values="prixVenteAdherent.prixVenteMoyenParAnnee"
                  :unite="'€/t'"
                />
              </div>
            </div>
          </PercentageDoughnut>
        </v-col>
        <v-col
          cols="12"
          md="5"
          align="center"
          class="align-self-center"
        >
          <div class="d-flex ml-3 ml-md-0">
            <div
              class="chiffre-xxl align-self-center positif-color"
            >
              {{ poidsVenduEnPourcentage }}
            </div>
            <div
              class="titre-h1 align-self-center ml-1 positif-color"
            >
              % vendus
            </div>
            <v-tooltip
              v-if="prixVenteAdherent.poidsVenduEnPourcentage == null"
              bottom
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  class="pt-1 ml-1"
                  v-on="on"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              Veuillez confirmer votre rendement sur la page Mes cultures.
            </v-tooltip>
          </div>
        </v-col>
      </v-row>
      <div
        v-if="prixVenteAdherent.prixVenteMoyenEnEuroParTonne != null && isAbonneCulturial"
        class="d-flex"
        :class="$vuetify.breakpoint.mobile ? 'mr-16' : ''"
      >
        <div
          v-if="!erreur.repartitionGroupe"
          class="align-self-center"
          :class="$vuetify.breakpoint.mobile ? 'mr-2' : 'position-indicateur-jauge'"
        >
          <UserIndicatorJauge
            :chargement="loading.repartitionGroupe"
            :data="{
              value: positionJaugeGroupe(repartitionPrixVenteGroupe?.codePositionDuNumtiers)
            }"
            :data-groupe="repartitionPrixVenteGroupe?.valeurMoyenneDuGroupe"
            :unite="'€/t'"
            :is-parametres-exploitation-incomplet="!isParametresExploitationComplet"
            :negative-color="repartitionPrixVenteGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#ec6608' : 'grey'"
            :positive-color="repartitionPrixVenteGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#01713c' : 'grey'"
          />
        </div>
        <AgrButton
          color="primary"
          large
          :block="$vuetify.breakpoint.mobile"
          class="align-self-center"
          :class="$vuetify.breakpoint.mobile ? '' : ' position-btn-plus-infos'"
          @click="openModaleDetail()"
        >
          <v-icon>mdi-magnify-plus-outline</v-icon>
          <span class="action text-truncate white--text">Plus d'infos</span>
        </AgrButton>
      </div>
    </div>
    <InformationAbonnementModal
      v-if="isOpenModalAideInformationAbonnement"
      :is-open-modal-information-abonnement="isOpenModalAideInformationAbonnement"
      code-feature="PRIX_EQUILIBRE_CULTURE"
      :texte="prixVenteAdherent.prixVenteMoyenEnEuroParTonne!= null ? 'Déterminez votre prix d\'équilibre par culture en €/t grâce à un expert, pour vous aider dans votre commercialisation.' : 'Ajouter un premier contrat pour avoir une analyse de votre prix de vente.'"
      titre="Mesurer la rentabilité technique et économique"
      :is-conseiller-pv-affiche="!isAbonneCulturial"
      @close="isOpenModalAideInformationAbonnement = false"
    />
    <HelpModal
      v-if="isOpenModalHelp"
      titre="Mon prix de vente"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-4">
          <p>Le prix de vente affiché est la moyenne des prix payés lorsqu'ils sont disponibles. En l'absence du prix payé, c'est le prix de contrat qui est considéré. Les prix de contrats ou les prix payés peuvent être provisoires (ex : acompte prix de campagne). Cette moyenne sera donc amenée à évoluer tout au long de la campagne de commercialisation.</p>
          <p class="pt-1">
            Lorsque qu'il n'y a pas de prix disponible (ex : contrat échange céréales, prix de campagne en amont de l'acompte), le contrat n'est alors pas pris en compte dans le calcul de la moyenne de prix.
          </p>
          <p class="pt-1">
            L'acompte et le poids du tréso moisson ne sont pas comptabilisés puisque le contrat final n'est pas encore fixé.
          </p>
          <p class="pt-1">
            <span class="black--text">Pourcentage vendu </span> = total des poids de contrats affectés à la culture / (rendement x surface) x 100.
          </p>
          <p class="pt-1">
            Ajoutez manuellement les contrats hors Agrial dans les rubriques suivantes :
          </p>
          <li class="pt-1 ml-4">
            Prix ferme sans option : Prix de marché, Terme moisson.
          </li>
          <li class="pt-1 ml-4">
            Prix ferme avec option : Prix minimum garanti, Agri'call.
          </li>
          <li class="pt-1 ml-4">
            Gestion déléguée : Prix de campagne, Septembre-avril, Novembre-mai.
          </li>
          <li class="pt-1 ml-4">
            Echanges ou autoconso. : échanges céréales semences, céréales-aliments, autoconsommation.
          </li>
          <li class="pt-1 ml-4">
            Filières : maïs waxy, blé noir tradition Bretagne, etc...  
          </li>
          <li class="pt-1 ml-4">
            Autres : ventes sur pied, autres ventes.
          </li>
        </div>
      </div>
    </HelpModal>
    <DetailPrixVenteModal
      v-if="isOpenModalDetail"
      :infos-abonnement="{code: 'GESTION_CONTRAT', titre:'Mesurer ma performance de vente', texte:'Gérer vos contrats par culture pour synthétiser votre année de commercialisation.'}"
      :type-culture-selected="typeCultureSelected"
      :is-open-modal-detail="isOpenModalDetail"
      :code-graine-culturial-selected="codeGraineCulturialSelected"
      :annee-recolte-selected="anneeRecolteSelected"
      class="pa-3"
      @close="isOpenModalDetail = false"
      @reload="loadDonneesAdherent"
    />
    <InfoModal
      v-if="isOpenModaleInfosManquantes"
      confirm-text="Renseigner les infos"
      titre="Infos manquantes"
      :is-open-modale-infos-manquantes="isOpenModaleInfosManquantes"
      @close="isOpenModaleInfosManquantes = false"
      @confirm="onPageMonCompte()"
    >
      <InfoManquanteContentModal />
    </InfoModal>
    <v-dialog
      v-model="isOpenModalEditContrat"
      :scrim="false"
      fullscreen
      transition="slide-x-transition"
      @click:outside="isOpenModalEditContrat = false"
    >
      <SaisieContratAdherentModal
        :contrat="null"
        :contrats-vente="contratsVente"
        :type-culture-selected="typeCultureSelected"
        @close="isOpenModalEditContrat = false"
        @reload="loadDonneesAdherentWithContrats"
      />
    </v-dialog>
    <v-dialog
      v-model="isOpenModalContratsRepartition"
      :scrim="false"
      scrollable
      :fullscreen="!$vuetify.breakpoint.mobile"
      :transition="$vuetify.breakpoint.mobile ? 'dialog-bottom-transition' : 'slide-x-transition'"
    >
      <ListeContratsARepartirAdherentModal
        class="pa-3"
        :type-culture-selected="typeCultureSelected"
        :contrats="contratsARepartir"
        @close="isOpenModalContratsRepartition = false"
        @reload="loadDonneesAdherentWithContrats"
      />
    </v-dialog>
    <v-dialog
      v-model="isOpenModalContratsPrixProvisoire"
      :scrim="false"
      scrollable
      :fullscreen="!$vuetify.breakpoint.mobile"
      :transition="$vuetify.breakpoint.mobile ? 'dialog-bottom-transition' : 'slide-x-transition'"
      @click:outside="isOpenModalContratsPrixProvisoire = false"
    >
      <ListeContratsPrixProvisoireAdherentModal
        class="pa-3"
        :type-culture-selected="typeCultureSelected"
        :contrats="contratsPrixProvisoire"
        @close="isOpenModalContratsPrixProvisoire = false"
        @reload="loadDonneesAdherentWithContrats"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { round } from 'lodash'
import { AgrButton } from '@agrial/ui'
import BaseEvolutionWithInfo from '@/components/common/base-evolution-with-info.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'
import ListeContratsARepartirAdherentModal from '../saisie-contrats/components/modal/liste-contrats-a-repartir-adherent-modal.vue'
import ListeContratsPrixProvisoireAdherentModal from '../saisie-contrats/components/modal/liste-contrats-prix-provisoire-adherent-modal.vue'
import PercentageDoughnut from '@/components/chart/v2/percentage-doughnut.vue'
import SaisieContratAdherentModal from '../saisie-contrats/components/modal/saisie-contrat-adherent-modal.vue'
import UserIndicatorJauge from '@/components/chart/v2/user-indicator-jauge.vue'
import DetailPrixVenteModal from './modal/detail-prix-vente-modal.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import InfoModal from '@/components/modal/info-modal.vue'
import InfoManquanteContentModal from '@/components/modal/info-manquante-content-modal.vue'

export default {
  name: 'PrixVente',
  components: { AgrButton, BaseEvolutionWithInfo, BaseLoader, BaseMessageServerError, DetailPrixVenteModal, HelpModal,InfoModal, InfoManquanteContentModal, InformationAbonnementModal, ListeContratsARepartirAdherentModal, ListeContratsPrixProvisoireAdherentModal, PercentageDoughnut, SaisieContratAdherentModal, UserIndicatorJauge },
  props: {
    grainesRs3Selected: {
      type: Array,
      default: null
    },
    codeGraineCulturialSelected: {
      type: String,
      default: null
    },
    anneeRecolteSelected: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      cancelError: false,
      isOpenModalHelp: false,
      isOpenModaleInfosManquantes: false,
      isOpenModalAideInformationAbonnement: false,
      isOpenModalDetail: false,
      isOpenModalEditContrat: false,
      isOpenModalContratsRepartition: false,
      isOpenModalContratsPrixProvisoire: false,
      isDisplayContratsEnAttente: false,
      loading: {
        repartitionAdherent: false,
        repartitionPrixVenteMoyens: false,
        repartitionGroupe: false,
        contratAdherent: false,
      },
      erreur: {
        repartitionAdherent: false,
        repartitionPrixVenteMoyens: false,
        repartitionGroupe: false,
        contratAdherent: false,
      }
    }
  },
  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements',
      cultures: 'culture/cultures',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      contractualisation: 'contratVente/contractualisation',
      prixVenteAdherent: 'contratVente/prixVenteAdherent',
      repartitionPrixVenteGroupe: 'contratVente/repartitionPrixVenteGroupe',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet'
    }),
    contratsVente () {
      return this.contractualisation!= null && this.contractualisation.contratVentes ? this.contractualisation.contratVentes : []
    },
    contratsPrixProvisoire () {
      let result = []
      let contrats = []
      if (this.contractualisation != null && this.contractualisation.contratVentes) {
        contrats = this.contractualisation.contratVentes.filter(c => (c.isPrixProvisoire || c.typePrix.code === 'PRIX_CONTRAT' || (c.typePrix.code ==='AUCUN' && c.typeContrat.code !=='ECHANGE' )) && !c.contratAgrial)
        if (contrats.length > 0) {
          contrats.forEach((contrat) => {
            let c = {}
            c.id = contrat.id
            c.dateCreation = contrat.dateCreation
            c.userCreation = contrat.userCreation
            c.numtiers = contrat.numtiers
            c.anneeRecolte = contrat.anneeRecolte
            c.libelle = contrat.libelle
            c.cultures = contrat.cultures
            c.typeContrat = contrat.typeContrat 
            c.typePrix = contrat.typePrix 
            c.isPrixProvisoire = contrat.isPrixProvisoire
            c.poidsEnTonne = contrat.poidsEnTonne
            c.prixPayeEnEuroParTonne = contrat.prixPayeEnEuroParTonne
            result.push(c)
          })
        }
      }
      return result
    },
    contratsARepartir () {
      return this.contractualisation!= null && this.contractualisation.contratVentes ? this.contractualisation.contratVentes.filter(c => c.contratAgrial && c.typeSaisie !== 'SAISIE_MANUELLE' && c.cultures.length > 1) : []
    },
    typeCultureSelected () {
      return this.cultures.find(c => c.typeCulture.code === this.codeGraineCulturialSelected)?.typeCulture
    },
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },
    poidsVenduEnPourcentage () {
      return this.prixVenteAdherent.poidsVenduEnTonne!= null && this.prixVenteAdherent.poidsVenduEnPourcentage!= null ? round(this.prixVenteAdherent.poidsVenduEnPourcentage, 0) : '-'
    },
    loadingGlobal () {
      return this.isAbonneCulturial && (this.loading.repartitionAdherent || this.loading.repartitionPrixVenteMoyens)
    },
    erreurGlobal () {
      return this.isAbonneCulturial && (this.erreur.repartitionAdherent || this.erreur.repartitionGroupe)
    }
  },
  watch: {
    codeGraineCulturialSelected () {
      this.cancelError = false
      this.loadDonneesAdherentWithContrats()
    },
    anneeRecolteSelected () {
      this.cancelError = false
      this.loadDonneesAdherentWithContrats()
    }
  },
  created () {
    this.loadDonneesAdherentWithContrats()
  },
  methods: {
    ...mapActions({
      getContrats: 'contratVente/getContractualisation',
      getPrixVenteCulture: 'contratVente/getPrixVenteCulture',
      getPrixVenteMoyenComparaison: 'contratVente/construireResumeGroupeRepartitionPrixVente',
      incrementerAccesSouscriptionAbonnement : 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement'
    }),
    loadDonneesAdherent () {
      this.loading.repartitionAdherent = true
      this.erreur.repartitionAdherent = false
      this.getPrixVenteCulture(this.codeGraineCulturialSelected)
        .then(() => {
          this.loadRepartitionPrixVenteMoyen()
        })
        .catch(() => this.erreur.repartitionAdherent = true)
        .finally(() => {
          this.loading.repartitionAdherent = false
        })
    },

    loadDonneesAdherentWithContrats () {
      if (!this.isAbonneCulturial) {
        this.erreur.repartitionAdherent = false
        this.loading.repartitionAdherent = false
        this.cancelError = false
        this.loadContratsAdherent()
        return
      }

      this.loading.contratAdherent = true
      this.erreur.contratAdherent = false
      this.loading.repartitionAdherent = true
      this.erreur.repartitionAdherent = false
      this.getPrixVenteCulture(this.codeGraineCulturialSelected)
        .then(() => {
          Promise.all([
            this.loadRepartitionPrixVenteMoyen(),
            this.loadContratsAdherent()
          ])
          this.cancelError = false
        })
        .catch((err) => {
          if (err.code === 'ERR_CANCELED') {
            this.cancelError = true
          } else {
            this.erreur.repartitionAdherent = true
          }
        }
        )
        .finally(() => {
          this.loading.repartitionAdherent = false
        })
    },
    loadRepartitionPrixVenteMoyen () {
      this.loading.repartitionPrixVenteMoyens = true
      this.erreur.repartitionPrixVenteMoyens = false
      const params = {
        codeGraine: this.codeGraineCulturialSelected,
        anneeRecolte: this.anneeRecolteSelected,
        filtres: this.filtresAdherent
      }
      this.getPrixVenteMoyenComparaison(params)
        .catch(() => {
          this.erreur.repartitionPrixVenteMoyens = true
        })
        .finally(() => {
          this.loading.repartitionPrixVenteMoyens = false
        })
    },
    loadContratsAdherent () {
      this.loading.contratAdherent = true
      this.erreur.contratAdherent = false
      this.getContrats(this.codeGraineCulturialSelected)
        .catch(() => this.erreur.contratAdherent = true)
        .finally(() => this.loading.contratAdherent = false)
    },
    onClickInformationAbonnement () {
      this.isOpenModalAideInformationAbonnement = true
      this.incrementerAccesSouscriptionAbonnement('PRIX_EQUILIBRE_CULTURE')
    },
    positionJaugeGroupe (codePosition) {
      let result = null
      switch (codePosition) {
        case 'QUARTILE_SUP':
          result = 'positive'
          break
        case 'QUARTILE_INF':
          result = 'negative'
          break
        case 'MOYENNE':
          result = 'center'
          break
      }
      return result
    },
    openModaleDetail () {
      if (this.isParametresExploitationComplet) {
      this.isOpenModalDetail = true
      } else {
        this.isOpenModaleInfosManquantes = true
      }
    },
    onPageMonCompte () {
      this.isOpenModalDetail = false
      this.$router.push({ name: 'main.compte' })
    },
  }
}

</script>
<style lang="scss" scoped>

.badge-content {
  display: flex;
  border-radius: 10px;
  border: 2px solid var(--orange-dark);
  justify-content: center;
  align-items: center;
  font-size: 12px;
  height: 100%;
  color: var(--orange-dark);
  background: white;
}
.positif-color {
  color: #dbbd00;
}

.position-indicateur-jauge {
  position: absolute;
  bottom: 18px;
  right: 180px;
}
.position-btn-plus-infos {
  position: absolute;
  bottom: 28px;
  right: 15px;
}
.position-btn-bell {
  position: absolute;
  top: 25px;
  right: 70px;
}

.position-btn-saisi-contrats-adherent {
  position: absolute;
  bottom: 85px;
  right: 15px;
}

.asterix {
  font-size: 0.875rem;
  color: var(--gris-fonce);
}
.menu-item-resume {
  position: relative;
  margin: 25px;
  padding: 4px;
  border-radius: 12px;
  background-color: #ffffff;
  filter: drop-shadow(
      0px 3px 1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2))
    )
    drop-shadow(
      0px 2px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14))
    )
    drop-shadow(
      0px 1px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12))
    );

  &.menu-item-resume__top {
    &::after {
      bottom: -5px;
      left: calc(50% - 10px);
      right: 0;
    }
  }

  &::after {
    content: '';
    position: absolute;
    z-index: -10;
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    background-color: #ffffff;
  }
}
.menu-item-resume-mobile {
  padding: 10px;
  width: 90%;
  margin: 20px;
  border-radius: 12px;
  background-color: #ffffff;
  filter: drop-shadow(
      0px 3px 1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2))
    )
    drop-shadow(
      0px 2px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14))
    )
    drop-shadow(
      0px 1px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12))
    );
}
.v-menu__content {
    position: absolute;
    display: inline-block;
    max-width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    contain: content;
    -webkit-box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
}
.badge .v-badge__badge {
  height: 30px;
  width: 30px;
}

.cursor-pointer {
  cursor: pointer;
}

</style>